import { createFileRoute } from "@tanstack/react-router";
import CardSendViewPage from "@/site/pages/card-send-view";

/**
 * The sender's view of a card they sent (legacy `/card/send/view/<magic_link>`). Auth +
 * must-be-sender, enforced server-side. URL shape is a hard constraint (PRD 03 §8.4).
 */
export const Route = createFileRoute("/card/send/view/$slug")({
  component: CardSendViewPage,
});
